import { lazy } from 'react';

const Privacy = lazy(() => import('./Privacy'));
const PrivacyDiamondSeminar = lazy(() => import('./PrivacyDiamondSeminar'));

export const DIAMOND_EVENT_IDX = Number(process.env.REACT_APP_DIAMOND_EVENT_IDX);

/**
 * eventIdx → Privacy 컴포넌트 매핑
 * 새 행사 추가 시 여기에 매핑만 추가하면 됨
 */
const privacyMap = {
    [DIAMOND_EVENT_IDX]: PrivacyDiamondSeminar, // 2026 다이아몬드 세미나
};

/**
 * eventIdx에 해당하는 Privacy 컴포넌트를 반환
 * 매핑이 없으면 기본 Privacy 컴포넌트 반환
 * @param {number|string|null} eventIdx
 * @returns {React.LazyExoticComponent}
 */
export const getPrivacyComponent = (eventIdx) => {
    if (eventIdx && privacyMap[eventIdx]) {
        return privacyMap[eventIdx];
    }
    return Privacy;
};
